<template>
	<div>
		<!-- 售后服务 -->
		<form action="" class="w-100 layui-form" method="post">
			<div class="user-info3 w-100 between-center">
				<el-date-picker v-model="date" value-format="yyyy-MM-dd" type="daterange" range-separator="——" start-placeholder="开始日期"
					end-placeholder="结束日期">
				</el-date-picker>
				<el-input placeholder="申请售后单号" v-model="suid"></el-input>
				<div class="btns">
					<input type="button" class="layui-btn layui-btn-normal" name="" id="" value="确定" @click="getSales"/>
					<input type="reset" class="layui-btn" name="" id="" value="重置" @click="reset" />
				</div>
			</div>
		</form>
		<div class="no-content" style="display: flex;justify-content: center;width: 100%;" v-if="list.length == 0">
			<img src="/static/img/no_data5.png">
		</div>
		<el-table v-tableDrag v-else :data="list" stripe style="width: 100%" @select-all="selectAll" @select="select" ref="multipleTable">
			<!-- <el-table-column type="selection" width="50" fixed></el-table-column> -->
			<el-table-column prop="whenCreated" label="申请时间" width="200" fixed></el-table-column>
			<el-table-column prop="" label="申请售后单号" width="200">
				<template slot-scope="scope">{{scope.row.number}}</template>
			</el-table-column>
			<el-table-column prop="" label="订单号" width="200">
				<template slot-scope="scope">{{scope.row.storeOrder.uid}}</template>
			</el-table-column>
			<el-table-column prop="" label="产品名称" width="200">
				<template slot-scope="scope">{{scope.row.orderStoreGoods.goodsName}}</template>
			</el-table-column>
			<el-table-column prop="address" label="产品型号" width="100">
				<template slot-scope="scope">{{scope.row.orderStoreGoods.goodsSpecInstName}}</template>
			</el-table-column>
			<el-table-column prop="address" label="数量" width="100">
				<template slot-scope="scope">{{scope.row.orderStoreGoods.amount}}</template>
			</el-table-column>
			<el-table-column prop="address" label="状态" width="100">
				<template slot-scope="scope">
					{{scope.row.state == -1?'未处理':scope.row.state == 1?'同意（待买家发货）':scope.row.state == 2?'驳回':scope.row.state == 3?'买家已发货':scope.row.state == 4?'已收货':scope.row.state == 8?'卖家已发货':scope.row.state == 9?'售后完成':scope.row.state == 11?'快递上门中':scope.row.state == 15?'售后结束':'已撤销'}}
				</template>
			</el-table-column>
			<el-table-column prop="address" label="操作" fixed="right">
				<template slot-scope="scope">
					<el-button type="warning" size="small" round @click="orderDetail(scope.row)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="user-info4 w-100 between-center" style="justify-content: center;" v-if="list.length != 0">
			<!-- <div class="f-l between-center">
				<label class="checkbox-inline"><input type="checkbox" class="checkbox-style allCheckbox" name="" id=""
						value="" :checked="allChecked" @change="toggleSelection" />&nbsp;</label>
				<span>删除所选</span>
			</div> -->
			<div class="fanye gray">
				<el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
					@current-change="currentChange" @prev-click="prevClick" @next-click="nextClick">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		aftersale
	} from '@/common/http.js';
	export default {
		data() {
			return {
				date: '',
				suid: '',
				list: [],
				total: 0,
				userInfo: {},
				pageSize: 5,
				pageIndex: 1,
				multipleSelection: [],
				allChecked: false
			}
		},
		mounted() {
			this.$emit('change_bread', 8);
			this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
			this.getSales();
		},
		methods: {
			getSales() {
				let datestr = '';
				if(this.date){
					datestr = this.date[0] + ',' + this.date[1] + ' 23:59:59'
				}
				aftersale({
					'creator.id': this.userInfo.id,
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					orderBy: 'id desc',
					between_whenCreated:datestr,
					like_number:this.suid,
				}).then(res => {
					if (res.result) {
						this.list = res.data.pList;
						this.total = res.data.rCount
					}
				})
			},
			currentChange(evt) {
				this.pageIndex = evt;
				this.getSales();
			},
			prevClick() {
				this.pageIndex -= 1;
				this.getSales();
			},
			nextClick() {
				this.pageIndex += 1;
				this.getSales();
			},
			reset() {
				this.date = '';
				this.suid = '';
				this.getSales();
			},
			// 全选
			selectAll(evt) {
				this.multipleSelection = evt;
			},
			// 单选
			select(evt) {
				let that = this;
				that.multipleSelection = evt;
				if(that.multipleSelection.length == 0){
					that.allChecked = false;
				}
				if(that.multipleSelection.length == that.list.length){
					that.allChecked = true;
				}
			},
			toggleSelection() {
				let that = this;
				that.allChecked = !that.allChecked;
				if (that.allChecked) {
					that.multipleSelection = that.list;
					that.list.forEach(row => {
						that.$refs.multipleTable.toggleRowSelection(row);
					})
				} else {
					that.multipleSelection = [];
					this.$refs.multipleTable.clearSelection();
				}
			},
			// 查看详情
			orderDetail(row) {
				this.$router.push({
					path: '/orderDetails',
					name: 'orderDetails',
					query: {
						id: row.id,
						aftersale:true
					}
				});
			}
		}
	}
</script>

<style scoped="scoped">
	/deep/ .el-checkbox__inner {
		width: 20px;
		height: 20px;
	}

	/deep/ .el-checkbox__inner::after {
		height: 9px;
		left: 7px;
		border-width: 2px;
	}

	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #004194;
		border-color: #004194;
	}

	/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
		height: 4px;
		top: 7px;
	}

	.el-button--warning {
		background-color: #004194;
		border-color: #004194;
	}

	.el-select {
		width: 31.5%;
		height: 2.875rem;
		border-radius: 0.375rem;
	}

	.el-input {
		width: 31.5%;
		height: 2.875rem;
		border-radius: 0.375rem;
	}

	.el-range-editor.el-input__inner {
		width: 31.5%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/userCenter/afterSaleService.vue